import { render, staticRenderFns } from "./whatsapp-templates.vue?vue&type=template&id=a4e900d2"
import script from "./whatsapp-templates.vue?vue&type=script&lang=js"
export * from "./whatsapp-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports